import { THINK_DROP_OVERLAY_HINT, THINK_DROP_OVERLAY_TITLE } from "@/lib/think-drop";
import { cn } from "@/lib/utils";

/**
 * Whole-panel drop highlight. Parent owns a dragenter/leave counter so
 * moving across children does not flicker. 1.5px copper dashed — Mission token.
 */
export function ThinkDropOverlay({
  active,
  fileName,
  className,
}: {
  active: boolean;
  fileName?: string | null;
  className?: string;
}) {
  return (
    <div
      data-testid="think-drop-overlay"
      aria-hidden={!active}
      className={cn(
        "absolute inset-0 z-30 flex flex-col items-center justify-center gap-1 px-4 text-center transition-opacity",
        active ? "pointer-events-auto" : "pointer-events-none",
        active ? "opacity-100" : "opacity-0",
        className,
      )}
      style={{
        border: "1.5px dashed #C45C26",
        background: active ? "color-mix(in srgb, #C45C26 10%, transparent)" : "transparent",
      }}
    >
      {active ? (
        <>
          <div className="text-[13px] font-semibold tracking-[0.02em] text-[#C45C26]">
            {THINK_DROP_OVERLAY_TITLE}
          </div>
          {fileName ? (
            <div className="max-w-full truncate font-mono text-[11px] text-foreground">{fileName}</div>
          ) : null}
          <div className="text-[11px] text-muted-foreground">{THINK_DROP_OVERLAY_HINT}</div>
        </>
      ) : null}
    </div>
  );
}
